import { jsx, jsxs } from "./chunk-EBMUSV7F.mjs";
import { neutralDay } from "./chunk-6NWZQNAN.mjs";
// src/icon/Navigation/NavigationClose.tsx
function NavigationClose(param) {
    var size = param.size, color = param.color;
    switch(size){
        case 16:
            return /* @__PURE__ */ jsxs("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /* @__PURE__ */ jsx("path", {
                        d: "M4 4L12 12",
                        stroke: color !== null && color !== void 0 ? color : neutralDay.gray90,
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    }),
                    /* @__PURE__ */ jsx("path", {
                        d: "M12 4L4 12",
                        stroke: color !== null && color !== void 0 ? color : neutralDay.gray90,
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                    })
                ]
            });
        case 20:
            return /* @__PURE__ */ jsxs("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /* @__PURE__ */ jsx("path", {
                        d: "M5 5L15 15",
                        stroke: color !== null && color !== void 0 ? color : neutralDay.gray90,
                        strokeWidth: "1.75",
                        strokeLinecap: "round"
                    }),
                    /* @__PURE__ */ jsx("path", {
                        d: "M15 5L5 15",
                        stroke: color !== null && color !== void 0 ? color : neutralDay.gray90,
                        strokeWidth: "1.75",
                        strokeLinecap: "round"
                    })
                ]
            });
        case 24:
            return /* @__PURE__ */ jsxs("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /* @__PURE__ */ jsx("path", {
                        d: "M6 6L18 18",
                        stroke: color !== null && color !== void 0 ? color : neutralDay.gray90,
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    }),
                    /* @__PURE__ */ jsx("path", {
                        d: "M18 6L6 18",
                        stroke: color !== null && color !== void 0 ? color : neutralDay.gray90,
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    })
                ]
            });
    }
}
export { NavigationClose };
